import React, { Component } from "react";
import queryString from 'query-string'
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing"
import "./Header.scss"

class Header extends Component {
  constructor() {
    super();
    this.state = {
      AppWebView: false
    }
  }
  componentDidMount() {
    const qs = queryString.parse(window.location.search);
    if(qs.appview == 1 && qs) {
      this.setState({
        AppWebView: true
      })
    }
  }
  render() {
    return (
      <header style={{ display: this.state.AppWebView ? "none" : "" }}>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <a href="https://www.frogi.co.il/" title="" target="_blank"><div className="logo"></div></a>
              </div>
              <div className="utils">
                <div className="share">
                  <div onClick={shareWhatsapp} className="whatsapp"></div>
                  <div onClick={shareFacebook} className="facebook"></div>
                  <div onClick={openNegishut} className="negishut"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtualHeader"></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx